import React from 'react'
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs"
import { SiUpwork } from "react-icons/si";
import { RxResume } from "react-icons/rx";
import profile from "../../assets/profile.png"
import "./Home.scss"
import Typewriter from "typewriter-effect";

const Home = () => {
  return (
    <div className="home">
      <div className="profile-pic">
        <div data-aos="zoom-in" className="img-div">
          <img className="home-img" src={profile} alt="" />
          <h2>
            MD Rokibul Islam <br /> Web Developer
          </h2>
          <a
            target="_blank"
            href="https://www.upwork.com/freelancers/~0111c5886bc961cace"
          >
            Hire Me
          </a>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-white text-4xl my-2 hover:scale-105 ease-in-out duration-500 hover:text-green-400">
            Hi! I AM
          </h1>
          <h1 className="text-white text-4xl hover:scale-105 ease-in-out duration-500 hover:text-green-400">
            MD ROKIBUL ISLAM
          </h1>
        </div>
        <div>
          <h4 className="my-2 text-2xl text-center hover:scale-105 ease-in-out duration-500 hover:text-green-50">
            <Typewriter
              options={{
                strings: [
                  "Frontend Web Developer",
                  "React Developer",
                  "MERN Stack Developer",
                ],
                autoStart: true,
                loop: true,
              }}
            />
          </h4>
        </div>
        <div className="hover:scale-105 ease-in-out duration-500">
          <a
            href="https://drive.google.com/uc?export=download&id=1weIT9AoB-RLFjE3lkjdGlpCt_0Uc6HF3"
            download
          >
            <button className="glass px-3 py-2 font-extrabold text-white hover:text-green-400 hover:ring-2 ring-green-500 ease-in duration-700">
              Download Resume
            </button>
          </a>
        </div>
        <div className="flex my-5 text-3xl space-x-4 ">
          <a
            className="hover:scale-105 hover:ring-4 ring-green-500 ease-in duration-300 rounded-full"
            target="_blank"
            href="https://github.com/rokibulslam"
          >
            <div
              data-aos="zoom-in"
              className="bg-white p-2 rounded-full text-black  "
            >
              <AiFillGithub />
            </div>
          </a>
          <a
            className="hover:scale-105 hover:ring-4 ring-green-500 ease-in duration-300 rounded-full"
            target="_blank"
            href="https://www.upwork.com/freelancers/~0111c5886bc961cace"
          >
            <div
              data-aos="zoom-in"
              className="text-green-400 p-2 rounded-full bg-white"
            >
              <SiUpwork />
            </div>
          </a>
          <a
            className="hover:scale-100 hover:ring-4 ring-green-500 ease-in duration-300 rounded-full"
            target="_blank"
            href="https://www.linkedin.com/in/rokibulslam/"
          >
            <div
              data-aos="zoom-in"
              className="text-white p-2 rounded-full bg-sky-600"
            >
              <AiFillLinkedin />
            </div>
          </a>
        </div>
      </div>
      <div></div>
    </div>
  );
}

export default Home